// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__qZn4u","categoryPage":"styles_categoryPage__ztPEG"};